module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/heading-mv-2154253b6eee8777ed01b6c92d2bd606.png";